
import * as handlebars_family from "../handlebars_family.ts";
import "../layout/layout_modal.mustache";
import "../widget/form/required.ts";
import "../widget/form/focusme.ts";
const TPL = handlebars_family.addTemplate("filer/file_edit",{"1":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return " <div class=\"V4 modal\" data-fw-meta-id=\""
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"metaId") : depth0), depth0))
    + "\"><form> "
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"metaId") : depth0),{"name":"if","hash":{},"fn":container.program(2, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":86},"end":{"line":1,"column":166}}})) != null ? stack1 : "")
    + " <div class=\"title\"> "
    + ((stack1 = lookupProperty(helpers,"i18n").call(depth0 != null ? depth0 : (container.nullContext || {}),"files.label.fileedit",{"name":"i18n","hash":{},"data":data,"loc":{"start":{"line":1,"column":187},"end":{"line":1,"column":220}}})) != null ? stack1 : "")
    + " <icon class=\"modal-close\" data-fw-onclick=\"modalclose\">"
    + container.escapeExpression((lookupProperty(helpers,"iconlib")||(depth0 && lookupProperty(depth0,"iconlib"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"ic_close",{"name":"iconlib","hash":{},"data":data,"loc":{"start":{"line":1,"column":276},"end":{"line":1,"column":298}}}))
    + "</icon></div><div class=\"content\"><flexrow><input name=\"name\" value=\""
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"name") : depth0), depth0))
    + "\" class=\"input flexauto\" type=\"text\" placeholder=\""
    + ((stack1 = lookupProperty(helpers,"i18n").call(depth0 != null ? depth0 : (container.nullContext || {}),"files.label.file",{"name":"i18n","hash":{},"data":data,"loc":{"start":{"line":1,"column":427},"end":{"line":1,"column":456}}})) != null ? stack1 : "")
    + "\" maxlength=\"200\" style=\"margin-top:0\" data-widget=\"widget/form/required widget/form/focusme\" /><span>"
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"extension") : depth0), depth0))
    + "</span></flexrow><button type=\"submit\" style=\"margin-top:16px;\"> "
    + ((stack1 = lookupProperty(helpers,"i18n").call(depth0 != null ? depth0 : (container.nullContext || {}),"actions.save",{"name":"i18n","hash":{},"data":data,"loc":{"start":{"line":1,"column":638},"end":{"line":1,"column":663}}})) != null ? stack1 : "")
    + " </button></div></form></div> ";
},"2":function(container,depth0,helpers,partials,data) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return " <input type=\"hidden\" name=\"metaId\" value=\""
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"metaId") : depth0), depth0))
    + "\"/> ";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = container.invokePartial(lookupProperty(partials,"layout/layout_modal"),depth0,{"name":"layout/layout_modal","fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "");
},"usePartial":true,"useData":true});
export default TPL;